/* eslint-disable no-magic-numbers */

import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import type { GetExpensesConfigResponseAPI } from '@omnipresentgroup/types';
import { HttpResponse, http } from 'msw';

import { API_CONFIG_PATH, API_PATH, API_UPLOAD_PATH } from './constants';
import {
  DEFAULT_BULK_UPDATE_EXPENSES_RESPONSE,
  DEFAULT_EXPENSE_DETAILS,
  DEFAULT_EXPENSES,
  EXPENSES_CONFIG_DEFAULT,
} from './fixtures';

export const expensesHandlers = [
  http.get(`*${API_PATH}/employee/:employeeId*`, () =>
    HttpResponse.json(DEFAULT_EXPENSES, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}/approver/:companyId`, () =>
    HttpResponse.json(DEFAULT_EXPENSES, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}/:expenseId`, () =>
    HttpResponse.json(DEFAULT_EXPENSE_DETAILS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.patch(`*${API_PATH}/:expenseId`, () =>
    HttpResponse.json(DEFAULT_EXPENSE_DETAILS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.patch(`*${API_PATH}`, () =>
    HttpResponse.json(DEFAULT_BULK_UPDATE_EXPENSES_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.post(`*${API_PATH}/export`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
  http.get<never, never, GetExpensesConfigResponseAPI>(
    `*/${API_PATH}/${API_CONFIG_PATH}`,
    () => {
      return HttpResponse.json(EXPENSES_CONFIG_DEFAULT, {
        status: HTTPStatusCodes.OK,
      });
    },
  ),
  http.post<never, never>(`*/${API_PATH}/${API_UPLOAD_PATH}`, () => {
    return HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    );
  }),
];
